const DAYS30 = 60 * 60 * 24 * 30;

export const setCookie = (name, value, maxAge = DAYS30) => {
  if (global.document) {
    document.cookie = `${name}=${value};max-age=${maxAge}`;
  }
};

export const deleteCookie = name => {
  if (global.document) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
};

// taken from: https://stackoverflow.com/questions/5639346/what-is-the-shortest-function-for-reading-a-cookie-by-name-in-javascript
export default function getCookieValue(cookieName) {
  var value = document.cookie.match(
    `(^|[^;]+)\\s*${cookieName}\\s*=\\s*([^;]+)`,
  );
  return value ? value.pop() : null;
}

// taken from: https://gist.github.com/rendro/525bbbf85e84fa9042c2#gistcomment-3076403
export const parseDocumentCookie = cookie =>
  Object.fromEntries(
    cookie.split(/; */).map(c => {
      const [key, ...v] = c.split('=');
      return [key, decodeURIComponent(v.join('='))];
    }),
  );
